import React, { PureComponent } from 'react';
import cx from 'classnames';

import './TextArea.scss';

interface TextAreaProps
    extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange' | 'onInput'> {
    onChange: (value: string, event: React.FocusEvent<HTMLTextAreaElement>) => void;
    onInput?: (value: string, event: React.FormEvent<HTMLTextAreaElement>) => void;
    maxHeight?: number;
}

export default class TextArea extends PureComponent<TextAreaProps> {
    static defaultProps = {
        maxHeight: 160,
    };

    _ref: HTMLTextAreaElement | null = null;

    componentDidMount() {
        setTimeout(() => { this.resize(); }, 10);
    }

    resize() {
        const { maxHeight } = this.props;

        if (!this._ref) return;

        this._ref.style.height = '';
        this._ref.style.height = Math.min(this._ref.scrollHeight, maxHeight ?? 160) + 'px';
    }

    handleRef = (elem: HTMLTextAreaElement | null) => this._ref = elem;

    handleInput = (event: React.FormEvent<HTMLTextAreaElement>) => {
        const { onInput } = this.props;
        this.resize();
        if (onInput) onInput(event.currentTarget.value, event);
    };

    handleChange = (event: React.FocusEvent<HTMLTextAreaElement>) => {
        const { onChange, defaultValue } = this.props;
        const { value } = event.currentTarget;
        if (!value && defaultValue == null || value === defaultValue) return;
        onChange(value, event);
    };

    render() {
        const { onChange, onInput, value, maxHeight, className, ...rest } = this.props;

        return (
            <textarea
                rows={1}
                {...rest}
                ref={this.handleRef}
                className={cx('TextArea-root', this.props.readOnly && 'TextArea-readOnly', className)}
                onBlur={this.handleChange}
                onInput={this.handleInput}
            />
        );
    }
}
